import { ReactElement } from "react";
import { Button as MUIButton, ButtonProps as MUIButtonProps } from "@mui/material";
import { LinkProps } from "react-router-dom";
import {
  ButtonIconLoadingPosition,
  UIComponentSize,
  ButtonStyleType,
  ButtonType,
  ColorType,
} from "@/types/shared/uiComponents";
import { useUILoadingContext } from "./utils/contexts";

interface CommonProps extends MUIButtonProps, Partial<Pick<LinkProps, "to">> {}

interface ButtonPropsWithStartIcon extends CommonProps {
  startIcon?: ReactElement;
  loadingPosition?: ButtonIconLoadingPosition.Start;
  endIcon?: never;
}

interface ButtonPropsWithEndIcon extends CommonProps {
  startIcon?: never;
  loadingPosition?: ButtonIconLoadingPosition.End;
  endIcon?: ReactElement;
}

type ButtonProps = ButtonPropsWithStartIcon | ButtonPropsWithEndIcon;

export default function Button({
  children,
  variant = ButtonStyleType.Contained,
  color = ColorType.Primary,
  size = UIComponentSize.Medium,
  type = ButtonType.Button,
  disabled,
  onClick,
  sx,
  fullWidth,
  ...props
}: ButtonProps) {
  const { initialLoading } = useUILoadingContext(props);

  return (
    <MUIButton
      color={color}
      variant={variant}
      size={size}
      type={type}
      disabled={disabled}
      loading={initialLoading}
      onClick={onClick}
      sx={sx}
      fullWidth={fullWidth}
      {...props}
    >
      {children}
    </MUIButton>
  );
}
